/* ============================================================
   spn-machine-core.js — 機種データの共通部品（機種ページ・メーカー一覧・機種名検索で共用）
   移植元: assets/machines.js（静的サンプル）の正規化・並べ替え・カード表示。
   データは spn-machines-data.js（window.SPN_MACHINE_DATA・スマスロ/スマパチのみ）を使う。
   以後はこのファイルで保守する（assets/machines.js から再生成しない）。
   ============================================================ */
(function () {
  "use strict";

  var DATA = window.SPN_MACHINE_DATA || { makers: {}, machines: [] };
  var MAKERS = DATA.makers;
  var MACHINES = DATA.machines;

  // 人気機種（見本 machines.js の POPULAR_SLUGS と同じ）
  var POPULAR_SLUGS = [
    "sammy-hokuto-tensei-2", "yamasa-monkey-turn-v", "sammy-bakemonogatari", "sammy-bakemonogatari-99",
    "mizuho-basilisk-zetsubou", "sammy-tokyo-revengers", "sankyo-symphogear-seigi", "daito-rezero-2"
  ];
  var TYPE_LABEL = { smaslo: "スマスロ", smapachi: "スマパチ" };

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", "\"": "&quot;", "'": "&#39;" }[c];
    });
  }
  // 画像 URL は https のみ表示（データ由来の想定外スキームを出さない）
  function safeImageUrl(u) { return /^https:\/\//.test(u || "") ? u : ""; }
  function machineUrl(slug) { return "/pages/machine/" + encodeURIComponent(slug); }
  function makerUrl(slug, type) {
    return "/pages/maker-list?m=" + encodeURIComponent(slug) + (type && type !== "all" ? "&machine_type=" + encodeURIComponent(type) : "");
  }
  function makerName(slug) { return (MAKERS[slug] && MAKERS[slug].name) || slug; }
  function getEnabled() { return MACHINES.filter(function (m) { return m.enabled; }); }
  function findMachine(slug) { return MACHINES.find(function (m) { return m.slug === slug; }) || null; }

  // ---- 検索正規化（scripts/build-machines.js と同じロジック）----
  function katakanaToHiragana(s) {
    return String(s).replace(/[ァ-ヶ]/g, function (ch) {
      return String.fromCharCode(ch.charCodeAt(0) - 0x60);
    });
  }
  function hiraganaToKatakana(s) {
    return String(s).replace(/[ぁ-ゖ]/g, function (ch) {
      return String.fromCharCode(ch.charCodeAt(0) + 0x60);
    });
  }
  var ROMAJI_DIGRAPH = {
    "きゃ":"kya","きゅ":"kyu","きょ":"kyo",
    "しゃ":"sha","しゅ":"shu","しょ":"sho","しぇ":"she",
    "ちゃ":"cha","ちゅ":"chu","ちょ":"cho","ちぇ":"che",
    "にゃ":"nya","にゅ":"nyu","にょ":"nyo",
    "ひゃ":"hya","ひゅ":"hyu","ひょ":"hyo",
    "みゃ":"mya","みゅ":"myu","みょ":"myo",
    "りゃ":"rya","りゅ":"ryu","りょ":"ryo",
    "ぎゃ":"gya","ぎゅ":"gyu","ぎょ":"gyo",
    "じゃ":"ja","じゅ":"ju","じょ":"jo","じぇ":"je",
    "びゃ":"bya","びゅ":"byu","びょ":"byo",
    "ぴゃ":"pya","ぴゅ":"pyu","ぴょ":"pyo",
    "ふぁ":"fa","ふぃ":"fi","ふぇ":"fe","ふぉ":"fo",
    "ゔぁ":"va","ゔぃ":"vi","ゔぇ":"ve","ゔぉ":"vo",
    "ゔゃ":"vya","ゔゅ":"vyu","ゔょ":"vyo",
    "うぃ":"wi","うぇ":"we","うぉ":"wo",
    "てぃ":"ti","でぃ":"di",
    "とぅ":"tu","どぅ":"du",
    "いぇ":"ye"
  };
  var ROMAJI_SINGLE = {
    "あ":"a","い":"i","う":"u","え":"e","お":"o",
    "か":"ka","き":"ki","く":"ku","け":"ke","こ":"ko",
    "さ":"sa","し":"shi","す":"su","せ":"se","そ":"so",
    "た":"ta","ち":"chi","つ":"tsu","て":"te","と":"to",
    "な":"na","に":"ni","ぬ":"nu","ね":"ne","の":"no",
    "は":"ha","ひ":"hi","ふ":"fu","へ":"he","ほ":"ho",
    "ま":"ma","み":"mi","む":"mu","め":"me","も":"mo",
    "や":"ya","ゆ":"yu","よ":"yo",
    "ら":"ra","り":"ri","る":"ru","れ":"re","ろ":"ro",
    "わ":"wa","を":"o","ん":"n",
    "が":"ga","ぎ":"gi","ぐ":"gu","げ":"ge","ご":"go",
    "ざ":"za","じ":"ji","ず":"zu","ぜ":"ze","ぞ":"zo",
    "だ":"da","ぢ":"ji","づ":"zu","で":"de","ど":"do",
    "ば":"ba","び":"bi","ぶ":"bu","べ":"be","ぼ":"bo",
    "ぱ":"pa","ぴ":"pi","ぷ":"pu","ぺ":"pe","ぽ":"po",
    "ゔ":"vu",
    "ぁ":"a","ぃ":"i","ぅ":"u","ぇ":"e","ぉ":"o",
    "ゃ":"ya","ゅ":"yu","ょ":"yo","ゎ":"wa",
    "ー":""
  };
  function kanaToRomaji(input) {
    var s = katakanaToHiragana(String(input));
    var out = "";
    var i = 0;
    while (i < s.length) {
      if (s[i] === "っ") {
        var nDi = s.substr(i + 1, 2);
        var nSi = s[i + 1];
        var peek = ROMAJI_DIGRAPH[nDi] || ROMAJI_SINGLE[nSi] || "";
        if (peek && /^[a-z]/.test(peek)) out += peek[0];
        i += 1;
        continue;
      }
      var di = s.substr(i, 2);
      if (ROMAJI_DIGRAPH[di]) { out += ROMAJI_DIGRAPH[di]; i += 2; continue; }
      var si = s[i];
      if (ROMAJI_SINGLE[si]) { out += ROMAJI_SINGLE[si]; i += 1; continue; }
      out += si;
      i += 1;
    }
    return out;
  }
  // クエリの複数形式を返す（部分一致用）
  function buildQueryForms(q) {
    var base = String(q || "").toLowerCase().trim();
    if (!base) return [];
    var forms = [base];
    var hira = katakanaToHiragana(base);
    var kata = hiraganaToKatakana(base);
    var romaji = kanaToRomaji(base);
    if (hira !== base) forms.push(hira);
    if (kata !== base) forms.push(kata);
    if (romaji !== base && romaji !== "") forms.push(romaji);
    return forms;
  }

  // 機種ソート用キー：接頭辞を剥がして カタカナ→ひらがな に揃えた 50音 順
  // 例：「スマスロ 北斗の拳」「Lパチスロ ありふれた職業」「e Re:ゼロ」→ 接頭辞除去 + 全部ひらがな化
  function machineSortKey(m) {
    var s = (m.name || "")
      .replace(/^(スマスロ|スマパチ|Lパチスロ|L パチスロ|スマート沖スロ|スマートぱちんこ|ぱちスロ|ぱちんこ|パチスロ|LB|スロット|デカスタe)\s*/, "")
      .replace(/^[eL](?=[A-Z0-9぀-ヿ一-鿿\s])\s*/, "")
      .trim();
    return katakanaToHiragana(s);
  }

  function machinesByMaker(makerSlug, excludeSlug, limit, type) {
    return getEnabled()
      .filter(function (m) { return m.maker === makerSlug && m.slug !== excludeSlug && (!type || type === "all" || m.machine_type === type); })
      .sort(function (a, b) { return machineSortKey(a).localeCompare(machineSortKey(b), "ja"); })
      .slice(0, limit || 8);
  }
  function popularMachines(excludeSlug, limit) {
    return POPULAR_SLUGS
      .filter(function (s) { return s !== excludeSlug; })
      .map(findMachine)
      .filter(function (m) { return m && m.enabled; })
      .slice(0, limit || 4);
  }

  // 見本 renderPlaceholderImage と同じ HTML
  function thumbHtml(m, sizeClass) {
    var maker = makerName(m.maker);
    var attrs = " data-machine-type=\"" + escapeHtml(m.machine_type) + "\" data-maker=\"" + escapeHtml(m.maker) + "\"";
    var classes = "machine-thumb " + (sizeClass || "");
    var img = safeImageUrl(m.image_url);
    if (img) {
      return "<div class=\"" + classes + " machine-thumb-photo\"" + attrs + "><img src=\"" + escapeHtml(img) + "\" alt=\"" +
        escapeHtml(m.name) + " / " + escapeHtml(maker) + "\" loading=\"lazy\" decoding=\"async\"></div>";
    }
    return "<div class=\"" + classes + " machine-placeholder\"" + attrs + "><div class=\"mp-content\">" +
      "<div class=\"mp-type-badge\">" + escapeHtml(TYPE_LABEL[m.machine_type] || "") + "</div>" +
      "<div class=\"mp-name\">" + escapeHtml(m.name) + "</div>" +
      "<div class=\"mp-maker\">" + escapeHtml(maker) + "</div></div></div>";
  }
  // 見本の機種カード（.machine-card）
  function cardHtml(m) {
    return "<a class=\"machine-card\" href=\"" + machineUrl(m.slug) + "\">" + thumbHtml(m, "machine-thumb-card") +
      "<div class=\"mc-body\"><div class=\"mc-maker\">" + escapeHtml(makerName(m.maker)) + "</div>" +
      "<div class=\"mc-name\">" + escapeHtml(m.name) + "</div></div></a>";
  }

  window.SPN_MACHINES = {
    makers: MAKERS, machines: MACHINES, TYPE_LABEL: TYPE_LABEL,
    escapeHtml: escapeHtml, machineUrl: machineUrl, makerUrl: makerUrl, makerName: makerName,
    getEnabled: getEnabled, findMachine: findMachine, machinesByMaker: machinesByMaker, popularMachines: popularMachines,
    machineSortKey: machineSortKey, katakanaToHiragana: katakanaToHiragana, buildQueryForms: buildQueryForms,
    thumbHtml: thumbHtml, cardHtml: cardHtml
  };
})();
